'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const ArticleCover = styled(Box)(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    ' .icon': {
        fontSize: '4rem',
        color: theme.palette.text.primary
    },
    '.label-number': {
        position: 'absolute',
        top: '0.25rem',
        left: '-0.6rem',
        zIndex: '1',
        fontWeight: '900',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '1.4rem',
        height: '1.4rem',
        borderRadius: '50%',
        backgroundImage: theme.palette.custom?.backgroundLabelInpressColor,
        border: `2px solid ${theme.palette.custom?.borderLabelInpressColor}`,
        boxShadow: '0 1px 2px rgba(51,51,51,0.5)',
        color: theme.palette.custom?.darkGray
    }
}));

export default ArticleCover;
